import { Paper, Button, Checkbox, Chip, FormControlLabel, FormGroup, Input, MenuItem, Select, TextField, useTheme, FormControl, InputLabel } from "@mui/material"
import { useState } from "react";
import useSideScreen from '../Layout/Hooks/useSideScreen'
import SelectionInput from "./SelectionInput";
import Text from "./Text";

const CustomInput = ({
    type,
    value,
    onChange,
    mandatory,
    placeholder,
    options,
    sidescreen,
    propertyName,
    sidescreenData,
    ...rest
}) => {
    const theme = useTheme()
    const [newValue, setNewValue] = useState("");
    const { openSideScreen } = useSideScreen()
    const addNewValue = () => {
        if (!newValue) {
            return;
        }
        onChange([...value, newValue])
        setNewValue("");
    }
    const removeFromList = index => {
        const newValueList = [...value]
        newValueList.splice(index, 1)
        onChange(newValueList)
    }
    const decToBin = dec => (dec >>> 0).toString(2);
    const binToDec = bin => parseInt(bin.toString(), 2)
    const updateFlaggedEnum = flaggedEnumVal => {
        const currentValBin = parseInt(decToBin(value))
        const flaggedEnumValBin = parseInt(decToBin(flaggedEnumVal))
        const newVal = binToDec((currentValBin + flaggedEnumValBin).toString().replace('2', '0'))
        onChange(newVal)
    }
    const checkFlaggedEnum = flaggedEnumVal => {
        const currentValBin = parseInt(decToBin(value))
        const flaggedEnumValBin = parseInt(decToBin(flaggedEnumVal))
        return (currentValBin + flaggedEnumValBin).toString().includes('2')
    }
    const checkDateTime = dateTimeVal => {
        const regex = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})$/g;
        if (dateTimeVal.match(regex)) {
            onChange(dateTimeVal);
        } else {
            onChange(dateTimeVal + ":00")
        }
    }    
    switch (type) {
        
        case 'String': return <TextField
            type='text'
            fullWidth
            {...rest}
            value={value}
            onChange={e => onChange(e.target.value)}
            required={mandatory}
            label={placeholder}
        />;
        case '[String]':
        case 'String[]': return <>
            <TextField
                fullWidth
                type='text'
                value={newValue}
                onChange={e => setNewValue(e.target.value)}
                onKeyDown={key => key.key === 'Enter' && addNewValue()}
                required={mandatory && value.length < 1}
                placeholder={<Text text={placeholder} />}
            />
            <Button onClick={addNewValue}>
                <Text text={"i18n_add"} />
            </Button>
            {value.map((x, i) => (
                <Chip
                    fullWidth
                    label={x}
                    style={{ marginRight: theme.spacing(.5) }}
                    color="secondary"
                    onDelete={() => removeFromList(i)}
                    variant="outlined"
                    key={i}
                />
            ))}
        </>
        case 'Double':
        case 'Float':
        case 'Int':
        case 'Integer': return <TextField 
                type="number"
                fullWidth
                variant="outlined"
                value={value??onChange(0)}
                onChange={e => { onChange((type === 'Double' || type === 'Float') ? parseFloat(e.target.value) : parseInt(e.target.value)) }}
                required={mandatory}
                label={placeholder}
                placeholder={placeholder}/>
        case 'Date': return <TextField
            type="date"
            value={value}
            fullWidth
            onChange={e => onChange(e.target.value)}
            required={mandatory}
            label={placeholder}
            placeholder={placeholder}
        />
        case 'DateTime': return <Input
            type="datetime-local"
            value={value}
            fullWidth
            onChange={e => checkDateTime(e.target.value)}
            required={mandatory}
            placeholder={<Text text={placeholder} />}
        />
        case 'ENUM':
        case 'Enum': return <FormControl fullWidth>
            <InputLabel id={"enum-" + placeholder}>{placeholder}</InputLabel>
            <Select
                value={value}
                id="demo-simple-select"
                label={placeholder}
                labelId={"enum-" + placeholder}
                onChange={e => onChange(e.target.value)}
                required={mandatory}
            >
                {options.map((x, i) => (
                    <MenuItem value={x} style={{ display: x == 'NONE' }} key={i}>{x}</MenuItem>
                ))}
            </Select>
        </FormControl>
        case 'Boolean': return (<FormControlLabel
            control={<Checkbox
                checked={value}
                fullWidth
                onChange={() => onChange(!value)}
            />}
            required={mandatory}
            label={<Text text={placeholder} />}
        />)
        case 'FlaggedEnum': return <>
            <label>{placeholder}</label>
            <FormGroup onChange={e => updateFlaggedEnum(e.target.value)}>
                {options.map((x, i) => (
                    <FormControlLabel
                        value={x.value}
                        label={<Text text={placeholder} />}
                        control={<Checkbox checked={checkFlaggedEnum(x.value)} />}
                        key={i}
                        style={{ display: x.hidden && 'none' }}
                    />
                ))}
            </FormGroup>
        </>
        case 'UUID': return <>
            <SelectionInput values={value} onSelectionChanged={onChange} propertyName={propertyName} />
        </>
        case 'Entity': return <>
            <Paper
                style={{ padding: theme.spacing(), cursor: 'pointer' }}
                onClick={() => openSideScreen(sidescreen, {
                    data: { ...sidescreenData }, notifyParent: res => {
                        onChange(res)
                    }
                })}
            >
                {value?.[0].displayName || placeholder}
            </Paper>
        </>
        default:
            if (options) {
                return <FormControl fullWidth>
                    <InputLabel id={"enum-" + placeholder}>{placeholder}</InputLabel>
                    <Select
                        value={value}
                        id="demo-simple-select"
                        label={placeholder}
                        labelId={"enum-" + placeholder}
                        onChange={e => onChange(e.target.value)}
                        required={mandatory}
                    >
                        {options.map((x, i) => (
                            <MenuItem value={x} style={{ display: x == 'NONE' }} key={i}>{x}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            } else {
                throw new Error(`${type} is not a supported type!`)
            }
            
    }
}

export default CustomInput
